import React from 'react';
import YoutubeCommentThreadsApi from '../../components/admin/YoutubeCommentThreadsApi';

const YoutubeCommentThreadsApiPage = () => {
  return <YoutubeCommentThreadsApi />;
};

export default YoutubeCommentThreadsApiPage;
